import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { Fonts, Spacings } from '@styles/index';

const P1 = styled.p`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
`;

export default P1;

P1.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

P1.defaultProps = {
  color: 'var(--color-text-primary)',
  lineClamp: null
};
